import React from 'react';
import './label.css'
const Label = ({value}) => {
    return (
        <>
            <label htmlFor="">{value}</label>
        </>
    );
}

export default Label;
